module.exports = __webpack_public_path__ + "img/linkedin-grey.5b8a3d64.svg";